import _slicedToArray from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { display, buildEndpointHost, mapValues, getCookie, addTelemetryMetrics, isIndexableObject, fetch } from '@datadog/browser-core';
import { parseJsonPath } from './jsonPathParser';
var REMOTE_CONFIGURATION_VERSION = 'v1';
var SUPPORTED_FIELDS = ['applicationId', 'service', 'env', 'version', 'sessionSampleRate', 'sessionReplaySampleRate', 'defaultPrivacyLevel', 'enablePrivacyForActionName', 'traceSampleRate', 'trackSessionAcrossSubdomains', 'allowedTracingUrls', 'allowedTrackingOrigins'];
export function fetchAndApplyRemoteConfiguration(_x, _x2) {
  return _fetchAndApplyRemoteConfiguration.apply(this, arguments);
}
function _fetchAndApplyRemoteConfiguration() {
  _fetchAndApplyRemoteConfiguration = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(initConfiguration, supportedContextManagers) {
    var rumInitConfiguration, metrics, fetchResult;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          metrics = initMetrics();
          _context.next = 1;
          return fetchRemoteConfiguration(initConfiguration);
        case 1:
          fetchResult = _context.sent;
          if (!fetchResult.ok) {
            metrics.increment('fetch', 'failure');
            display.error(fetchResult.error);
          } else {
            metrics.increment('fetch', 'success');
            rumInitConfiguration = applyRemoteConfiguration(initConfiguration, fetchResult.value, supportedContextManagers, metrics);
          }
          // monitor-until: forever
          addTelemetryMetrics("remote configuration metrics" /* TelemetryMetrics.REMOTE_CONFIGURATION_METRIC_NAME */, {
            metrics: metrics.get()
          });
          return _context.abrupt("return", rumInitConfiguration);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchAndApplyRemoteConfiguration.apply(this, arguments);
}
export function applyRemoteConfiguration(initConfiguration, rumRemoteConfiguration, supportedContextManagers, metrics) {
  // intents:
  // - explicitly set each supported field to limit risk in case an attacker can create configurations
  // - check the existence in the remote config to avoid clearing a provided init field
  var appliedConfiguration = _objectSpread({}, initConfiguration);
  SUPPORTED_FIELDS.forEach(function (option) {
    if (option in rumRemoteConfiguration) {
      appliedConfiguration[option] = resolveConfigurationProperty(rumRemoteConfiguration[option]);
    }
  });
  Object.keys(supportedContextManagers).forEach(function (context) {
    if (rumRemoteConfiguration[context] !== undefined) {
      resolveContextProperty(supportedContextManagers[context], rumRemoteConfiguration[context]);
    }
  });
  return appliedConfiguration;
  // share context to access metrics
  function resolveConfigurationProperty(property) {
    if (Array.isArray(property)) {
      return property.map(resolveConfigurationProperty);
    }
    if (isIndexableObject(property)) {
      if (isSerializedOption(property)) {
        var type = property.rcSerializedType;
        switch (type) {
          case 'string':
            return property.value;
          case 'regex':
            return resolveRegex(property.value);
          case 'dynamic':
            return resolveDynamicOption(property);
          default:
            display.error("Unsupported remote configuration: \"rcSerializedType\": \"".concat(type, "\""));
            return;
        }
      }
      return mapValues(property, resolveConfigurationProperty);
    }
    return property;
  }
  function resolveContextProperty(contextManager, contextItems) {
    contextItems.forEach(function (_ref) {
      var key = _ref.key,
        value = _ref.value;
      contextManager.setContextProperty(key, resolveConfigurationProperty(value));
    });
  }
  function resolveDynamicOption(property) {
    var strategy = property.strategy;
    var resolvedValue;
    switch (strategy) {
      case 'cookie':
        resolvedValue = resolveCookieValue(property);
        break;
      case 'dom':
        resolvedValue = resolveDomValue(property);
        break;
      case 'js':
        resolvedValue = resolveJsValue(property);
        break;
      case 'localStorage':
        resolvedValue = resolveLocalStorageValue(property);
        break;
      default:
        display.error("Unsupported remote configuration: \"strategy\": \"".concat(strategy, "\""));
        return;
    }
    var extractor = property.extractor;
    if (extractor !== undefined && typeof resolvedValue === 'string') {
      return extractValue(extractor, resolvedValue);
    }
    return resolvedValue;
  }
  function resolveCookieValue(_ref2) {
    var name = _ref2.name;
    var value = getCookie(name);
    metrics.increment('cookie', value !== undefined ? 'success' : 'missing');
    return value;
  }
  function resolveLocalStorageValue(_ref3) {
    var key = _ref3.key;
    var value;
    try {
      value = localStorage.getItem(key);
    } catch (_a) {
      metrics.increment('localStorage', 'failure');
      return;
    }
    metrics.increment('localStorage', value !== null ? 'success' : 'missing');
    return value !== null && value !== void 0 ? value : undefined;
  }
  function resolveDomValue(_ref4) {
    var selector = _ref4.selector,
      attribute = _ref4.attribute;
    var element;
    try {
      element = document.querySelector(selector);
    } catch (_a) {
      display.error("Invalid selector in the remote configuration: '".concat(selector, "'"));
      metrics.increment('dom', 'failure');
      return;
    }
    if (!element) {
      metrics.increment('dom', 'missing');
      return;
    }
    if (isForbidden(element, attribute)) {
      display.error("Forbidden element selected by the remote configuration: '".concat(selector, "'"));
      metrics.increment('dom', 'failure');
      return;
    }
    var domValue = attribute !== undefined ? element.getAttribute(attribute) : element.textContent;
    if (domValue === null) {
      metrics.increment('dom', 'missing');
      return;
    }
    metrics.increment('dom', 'success');
    return domValue;
  }
  function isForbidden(element, attribute) {
    return element.getAttribute('type') === 'password' && attribute === 'value';
  }
  function resolveJsValue(_ref5) {
    var path = _ref5.path;
    var current = window;
    var pathParts = parseJsonPath(path);
    if (pathParts.length === 0) {
      display.error("Invalid JSON path in the remote configuration: '".concat(path, "'"));
      metrics.increment('js', 'failure');
      return;
    }
    var _iterator = _createForOfIteratorHelper(pathParts),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var pathPart = _step.value;
        if (!(pathPart in current)) {
          metrics.increment('js', 'missing');
          return;
        }
        try {
          current = current[pathPart];
        } catch (e) {
          display.error("Error accessing: '".concat(path, "'"), e);
          metrics.increment('js', 'failure');
          return;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    metrics.increment('js', 'success');
    return current;
  }
}
export function initMetrics() {
  var metrics = {
    fetch: {}
  };
  return {
    get: function get() {
      return metrics;
    },
    increment: function increment(metricName, type) {
      if (!metrics[metricName]) {
        metrics[metricName] = {};
      }
      if (!metrics[metricName][type]) {
        metrics[metricName][type] = 0;
      }
      metrics[metricName][type] = metrics[metricName][type] + 1;
    }
  };
}
function isSerializedOption(value) {
  return 'rcSerializedType' in value;
}
function resolveRegex(pattern) {
  try {
    return new RegExp(pattern);
  } catch (_a) {
    display.error("Invalid regex in the remote configuration: '".concat(pattern, "'"));
  }
}
function extractValue(extractor, candidate) {
  var resolvedExtractor = resolveRegex(extractor.value);
  if (resolvedExtractor === undefined) {
    return;
  }
  var regexResult = resolvedExtractor.exec(candidate);
  if (regexResult === null) {
    return;
  }
  var _regexResult = _slicedToArray(regexResult, 2),
    match = _regexResult[0],
    capture = _regexResult[1];
  return capture ? capture : match;
}
export function fetchRemoteConfiguration(_x3) {
  return _fetchRemoteConfiguration.apply(this, arguments);
}
function _fetchRemoteConfiguration() {
  _fetchRemoteConfiguration = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(configuration) {
    var response, remoteConfiguration, _t;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 1;
          return fetch(buildEndpoint(configuration));
        case 1:
          response = _context2.sent;
          _context2.next = 3;
          break;
        case 2:
          _context2.prev = 2;
          _t = _context2["catch"](0);
          response = undefined;
        case 3:
          if (!(!response || !response.ok)) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return", {
            ok: false,
            error: new Error('Error fetching the remote configuration.')
          });
        case 4:
          _context2.next = 5;
          return response.json();
        case 5:
          remoteConfiguration = _context2.sent;
          if (!remoteConfiguration.rum) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return", {
            ok: true,
            value: remoteConfiguration.rum
          });
        case 6:
          return _context2.abrupt("return", {
            ok: false,
            error: new Error('No remote configuration for RUM.')
          });
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 2]]);
  }));
  return _fetchRemoteConfiguration.apply(this, arguments);
}
export function buildEndpoint(configuration) {
  if (configuration.remoteConfigurationProxy) {
    return configuration.remoteConfigurationProxy;
  }
  return "https://sdk-configuration.".concat(buildEndpointHost('rum', configuration), "/").concat(REMOTE_CONFIGURATION_VERSION, "/").concat(encodeURIComponent(configuration.remoteConfigurationId), ".json");
}